import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./DealerApprovalPage.css";

export default function DealerApprovalPage(){

const navigate = useNavigate();


return (

<div className="approval-page">


<motion.div

className="approval-card"

initial={{
opacity:0,
scale:.9
}}

animate={{
opacity:1,
scale:1
}}

transition={{
duration:.5
}}

>


<div className="approval-icon">
✓
</div>


<h1>
Registration Submitted
</h1>


<p className="approval-main">

Thank you for joining BuildNear.

</p>


<p className="approval-text">

Your dealer profile has been submitted successfully.
Our admin team will verify your details and activate your account.

</p>



<div className="approval-status">


<div>
<span>
1
</span>

Registration Completed

</div>


<div className="active">
<span>
2
</span>

Admin Verification

</div>


<div>
<span>
3
</span>

Account Activation

</div>


</div>




<button

onClick={() =>
navigate("/dealer/login")
}

>

Go To Dealer Login

</button>



</motion.div>


</div>

);

}